import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css';
import { Home } from './Component/Home';
import { Connection } from './Component/Connection';
import { Inscription } from './Component/Inscription';
import { Profil } from './Component/Profil';
import {Taxe} from './Component/Taxe'
import { Provider } from 'react-redux';
import {store} from './Routes/index'


function App() {
  
  


  return (
    <Provider store={store}>
        <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route
          path='connection'
          element={
            <Connection key="connection-unique-key"/>
          }
        />
        <Route
          path='inscription'
          element={
            <Inscription key="inscription-unique-key"/>
          }
        />
         <Route
          path='profil'
          element={
            <Profil key="profil-unique-key"/>
          }
        />
         <Route
          path='taxe'
          element={
            <Taxe key="taxe-unique-key"/>
          }
        />
      </Routes>
    </BrowserRouter>

   </div>
   </Provider>
  );
}

export default App;
